import React from 'react'
import { Icon } from '@chakra-ui/react'

export function IconArrowLeft(rest) {
  return (
    <Icon viewBox="0 0 24 24" {...rest}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        fill="none"
        d="M7 16l-4-4m0 0l4-4m-4 4h18"
      />
    </Icon>
  )
}
